import React, { useState, useEffect, useRef, useCallback } from "react";
import { useWebhookEvents } from '../../../hooks/useWebhookEvents';
import { useAccess } from '../../../hooks/useAccessScreen';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import Box from "@mui/material/Box";
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { Messages } from "../../../components/whatsApp/chat/chat/Messages/Messages";
import { HeaderChat } from "../../../components/whatsApp/chat/chat/HeaderChat";
import { MenuContacts } from "../../../components/whatsApp/menu/MenuContacts";
import { ChatInputBar } from '../../../components/whatsApp/chat/ChatInputBar';
import { ChatEmpty } from "../../../components/whatsApp/chat/chat/ChatEmpty";
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { getContacts, sendRequest, buildContent, createWebhookPayload } from "../../../services/whatsApp.service";
import { getInitialMessages, getTemplates, getUsers } from "../../../services/whatsApp.service";
import { getCompanies } from '../../../services/client.service';
import { transformMessages } from '../../../utils/whatsApp/transformMessages';
import { useManageSharedViews } from '../../../screens/sharedViews/hooks/useManageSharedViews';

import '../../../styles/components/_whatsApp.scss';

export default function WhatsAppLayout({ config = null }) {

    const {
        // isMobileScreen,
        // DocManager,
        // configuration,
        // buttons,
        buttons,
        // columns,
        id_user_action,
        // companies,
        // openDialogCompany,
        // expandedId,
        // anchorEl,
        // //REDUX DATA
        // listAllDocs,
        // isLoading,
        // rowsChecked,
        // filters,
        // pagination,
        // counter,
        // //REDUX DATA
        // // custom functions
        // t,
        // setAnchorEl,
        // handleConfirmAction,
        // handleChangePage,
        // handleChangeRowsPerPage,
        // Search,
        // ResetSearch,
        // RefreshTable,
        // handleCheckAll,
        // handleCheck,
        // handleLoadMore,
        // isCheck,
        // Cancel
        // custom functions
    } = useManageSharedViews(config);


    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // ----- mode flags / parameters -----
    // The support component will eventually navigate here passing
    // For now we hard‑code a value to be able to test the second mode.
    const supportParamsFromState = {
        chatId: location.state.config.data?.id_marketing_whatsapp || '',
        companyId: location.state.config.data?.id_company || ''
    };

    // Hardcode for testing.
    // const HARD_CODED_SUPPORT_CHAT_ID = 27;
    // const HARD_CODED_SUPPORT_COMPANY_ID = 5;
    const HARD_CODED_SUPPORT_CHAT_ID = '';
    const HARD_CODED_SUPPORT_COMPANY_ID = '';

    const [singleChatMode, setSingleChatMode] = useState(false);
    const [singleChatId, setSingleChatId] = useState('');
    const [singleCompanyId, setSingleCompanyId] = useState('');

    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [chatSelected, setChatSelected] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [idCompany, setIdCompany] = useState('');
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [messages, setMessages] = useState([]);
    const [headerConfiguration, setHeaderConfiguration] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [users, setUsers] = useState([]);
    const chatContainerRef = useRef(null);
    const [view, setView] = useState('contacts');
    const { access, loadingAccess } = useAccess("MENU-WHATSAPP", "", setLoading);
    useWebhookEvents(access?.viewAll, chatSelected, setMessages, setContacts);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [messages]);

    // determine support mode once on mount (could also be done via props)
    useEffect(() => {
        const paramChat = supportParamsFromState.chatId || HARD_CODED_SUPPORT_CHAT_ID;
        const paramCompany = supportParamsFromState.companyId || HARD_CODED_SUPPORT_COMPANY_ID;

        if (paramChat) {
            setSingleChatMode(true);
            setSingleChatId(paramChat);
        }
        if (paramCompany) {
            setSingleCompanyId(paramCompany);
            // if a company id comes from support component we can pre‑select it
            setIdCompany(paramCompany);
            setOpenDialogCompany(false);
        }
    }, []);

    useEffect(() => {
        if (loadingAccess) return;

        const performRegularFetch = async () => {
            setLoading(true);
            try {
                await fetchContacts(access?.viewAll);
                await fetchDataCompany();
            } catch (e) {
                console.error("Error fetching data", e);
            } finally {
                setLoading(false);
            }
        };

        const performSupportFetch = async () => {
            setLoading(true);
            try {
                const loaded = await fetchContacts(access?.viewAll, singleChatId);
                // make sure company data is resolved; pass the support-specific id if available
                await fetchDataCompany(singleCompanyId);

                if (loaded && loaded.length) {
                    // automatically open the requested chat using the freshly fetched list
                    await handleChatSelect(singleChatId, loaded);
                }
            } catch (e) {
                console.error("Error fetching support data", e);
            } finally {
                setLoading(false);
            }
        };

        if (singleChatMode) {
            performSupportFetch();
        } else if (location.state && location.state.config) {
            performRegularFetch();
        }
    }, [location.state, loadingAccess, access?.viewAll, singleChatMode, singleChatId, singleCompanyId]);

    useEffect(() => {
        const fetchData = async () => {
            if (!idCompany) return;
            try {
                const response = await getTemplates(userSession.token, idCompany);
                if (access.changeResponsability) {
                    const responseUsers = await getUsers(idCompany, userSession.token);
                    if (responseUsers?.data?.length) {
                        setUsers(responseUsers.data)
                    }
                }
                if (response?.data?.length) {
                    setTemplates(response.data);
                }
            } catch (error) {
                console.error('Error fetching templates:', error);
            }
        };
        fetchData();
    }, [idCompany, userSession.token]);

    // fetch list of contacts; an optional filterId will limit the result to a
    // single contact (used by single mode).
    const fetchContacts = async (allAccess = false, filterId = null) => {
        try {
            const responseContacts = await getContacts(
                allAccess ? 'NOT_BY_USER' : "BY_USER",
                userSession.token
            );
            if (responseContacts?.data) {
                let data = responseContacts.data;
                if (filterId) {
                    data = data.filter(c => c.id_marketing_whatsapp === filterId);
                }
                setContacts(data);
                return data;
            }
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
        return [];
    };

    // optionally accept a companyId to avoid prompting the user
    const fetchDataCompany = async (forcedId) => {
        if (forcedId) {
            setIdCompany(forcedId);
            setOpenDialogCompany(false);
            return;
        }
        try {
            const response = await getCompanies('77', userSession.token);
            const companiesData = response.data || [];
            setCompanies(companiesData);
            if (companiesData.length === 1) {
                const dto = companiesData[0];
                setIdCompany(dto.id_company);
                setOpenDialogCompany(false);
            } else {
                setOpenDialogCompany(true);
            }
        } catch (e) {
            console.error(e.message);
        }
    };

    // accepts optionally a contact list to avoid relying on stale `contacts` state
    const handleChatSelect = async (id_marketing_whatsapp, list = contacts) => {
        const contact = list.find(user => user.id_marketing_whatsapp === id_marketing_whatsapp);
        setChatSelected(contact);
        setView('chat');
        const responseMessages = await getInitialMessages(userSession.token, id_marketing_whatsapp);
        if (responseMessages && responseMessages.data) {
            transformMessages(responseMessages.data.messages, setMessages);
            setContacts(prevUsers =>
                prevUsers.map(user => user.id_marketing_whatsapp === id_marketing_whatsapp ? { ...user, message_pending: 0 } : user)
            );
            setHeaderConfiguration(contact.configuration);
            // transformMessages(testingMessages.messages, setMessages);
        } else {
            setMessages([]);
        }
    };

    const handleSend = async ({ type, value, name = null, mimeType = null, animated = null }) => {
        if (!chatSelected) return;
        const content = buildContent({ type, value, name, mimeType, animated, chatSelected, idCompany });
        let payload = {};
        if (type !== 'template') {
            payload = createWebhookPayload({
                wa_id: chatSelected.cellphone,
                type,
                content,
                value,
                chatSelected,
                idCompany
            });
        } else {
            payload = content;
        }
        const response = await sendRequest(userSession.token, payload);
        console.log('response ', response);
        if (response.status === 200) {
            const responseMessages = await getInitialMessages(userSession.token, chatSelected.id_marketing_whatsapp);

            if (responseMessages && responseMessages.data) {
                console.log(responseMessages.data);
                transformMessages(responseMessages.data.messages, setMessages);
            }
        }
    };

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1)
    };

    const handleConfirmAction = useCallback(async (dto) => {
        setIdCompany(dto.id_company)
        setOpenDialogCompany(false);
    }, []);

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const goBack = () => {
        navigate(-1);
    };

    // if singleChatMode is active and a chat is already open, we don't need the
    // contacts panel at all (even on desktop). on mobile the existing logic also
    // hides the panel when view==='chat'.
    // const showContactsPanel = !(singleChatMode && view === 'chat') && !(isMobile && view === 'chat');
    const showContactsPanel = !(isMobile && view === 'chat');

    return (
        <Box sx={{ display: 'flex', height: '100vh', backgroundColor: '#111b21', color: 'white' }}>
            <Box
                sx={{
                    width: showContactsPanel ? { xs: '100%', md: '25%', lg: '25%' } : '0%',
                    display: showContactsPanel ? 'flex' : 'none',
                    // display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#202c33',
                    borderRight: '1px solid #2a3942',
                    height: '100vh',
                    transition: 'all 0.3s ease',
                    overflowY: 'auto',
                }}
            >
                <MenuContacts
                    idCompany={idCompany}
                    contacts={contacts}
                    users={users}
                    access={access}
                    handleChatSelect={handleChatSelect}
                    fetchContacts={fetchContacts}
                    singleChatMode={singleChatMode}
                    buttons={buttons}
                    id_user_action={id_user_action}
                />
            </Box>

            {/* Chat window */}
            <Box
                sx={{
                    flex: 1,
                    display: (isMobile && view === 'contacts') ? 'none' : 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#111b21',
                    height: '100vh',
                    transition: 'all 0.3s ease',
                    minWidth: 0,
                }}
            >
                {chatSelected ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <HeaderChat setContacts={setContacts} setChatSelected={(val) => { setChatSelected(val); setView('contacts'); }} chatSelected={chatSelected} singleChatMode={singleChatMode} goBack={goBack} configuration={headerConfiguration} />
                        <Messages messages={messages} />
                        <ChatInputBar handleSend={handleSend} chatSelected={chatSelected} templates={templates} messages={messages} />
                    </Box>
                ) : (
                    <ChatEmpty />
                )}
            </Box>
            <DialogSelectCompany
                openDialogConfirm={openDialogCompany}
                handleCancelConfirm={Cancel}
                handleConfirmAction={handleConfirmAction}
                data={companies}
            />
            <LoadingOverlay isOpen={loading} />
        </Box>
    );
}